import { Platform, useWindowDimensions } from "react-native"
import { WEB_MAX_WIDTH, WEB_MAX_WIDTH_FOR_BANNER, WEB_MAX_WIDTH_FOR_ORGANIZATION_ICON } from "src/constants/Screen"

export const usePseudoWindowDimensions = () => {
  const dimensions = useWindowDimensions()
  const width = Platform.OS !== "web" || dimensions.width < WEB_MAX_WIDTH ? dimensions.width : WEB_MAX_WIDTH
  const height = dimensions.height
  const scale = dimensions.scale
  const fontScale = dimensions.fontScale
  return {width, height, scale, fontScale}
}

export const usePseudoWindowWidth = () => {
  const dimensions = useWindowDimensions()
  return Platform.OS !== "web" || dimensions.width < WEB_MAX_WIDTH ? dimensions.width : WEB_MAX_WIDTH
}

export const usePseudoWindowWidthForBanner = () => {
  const dimensions = useWindowDimensions()
  return Platform.OS !== "web" || dimensions.width < WEB_MAX_WIDTH_FOR_BANNER ? dimensions.width : WEB_MAX_WIDTH_FOR_BANNER
}

export const usePseudoWindowWidthForOrganizationIcon = () => {
  const dimensions = useWindowDimensions()
  return Platform.OS !== "web" || dimensions.width < WEB_MAX_WIDTH_FOR_ORGANIZATION_ICON ? dimensions.width : WEB_MAX_WIDTH_FOR_ORGANIZATION_ICON
}